export const LocalStorageKeys = {
    LAST_PLAYED_VIDEO_ARCHIVE_CLIP: 'last_played_clip',
    LAST_PLAYED_VIDEO_BY_EVENT: 'video_archive_most_recently_watched',
    CLIP_TIMESTAMP_KEY: 'video_archive_resume_positions',
    PLAYS_SETTING: 'plays_setting',
    TEAMS_ALREADY_PROMPTED: 'teams_already_prompted',
    TEAM_SCHEDULE_WIDGET_PROMOTION_DISMISSED: 'team_schedule_widget_promotion_dismissed',
    REFERRAL_CODE: 'referral_code',
    REFERRAL_FIRST_USE: 'referral_code_first_use',
    DISCOUNT_CODE: 'discount_code',
    GAME_INSIGHT_ALREADY_RATED: 'game_insight_already_rated',
    GAME_INSIGHT_SURVEY_TAKEN: 'game_insight_survey_taken',
    LOCATION_PERMISSION_DENIED: 'location_permission_denied',
    ORG_ANNOUNCEMENT_TOOLTIP_VISIBLE: 'org_announcement_tooltip_visible',
    TEAM_ANNOUNCEMENT_TOOLTIP_VISIBLE: 'team_announcement_tooltip_visible',
    TEAMS_TAB_TOOLTIP_VISIBLE: 'teams_tab_tooltip_visible',
    SITUATIONAL_STATS_TOOLTIP_VISIBLE: 'situational_stats_tooltip_visible',
    SITUATIONAL_STATS_PLAYER_TOOLTIP_VISIBLE: 'situational_stats_player_tooltip_visible',
    EDEN_BASE_URL_OVERRIDE: 'eden_base_url_override',
    EDEN_AUTH_CLIENT_KEY_OVERRIDE: 'eden_auth_client_key_override',
} as const;

type Key = keyof typeof LocalStorageKeys;

export type LocalStorageKey = (typeof LocalStorageKeys)[Key];
